import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Entrar',
  subtitle: 'Use o e-mail da conta de parceiro.',
  email: 'E-mail',
  emailPlaceholder: 'contato@suaorganizacao.com.br',
  password: 'Senha',
  forgotPassword: 'Esqueceu sua senha?',
  hidePassword: 'Ocultar senha',
  showPassword: 'Mostrar senha',
  signIn: 'Entrar',
  signInError: 'Não foi possível entrar, verifique e-mail e senha',
} satisfies TranslationTree;
